<!--
 * @Description: 项目配置人员
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-25 14:49:47
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-03-30 10:32:23
 -->
<template>
  <div class="projectPersonnel">
    <div class="itemContainer">
      <div class="item" v-for="(item, index) in list" :key="index">
        <div class="personnel">
          {{item.name}}配置人员： <span class="value">{{item.staffing}}</span> 人
        </div>
        <div class="protectDays">
          守护天数： <span class="value">{{item.guardDays}}</span> 天
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'projectPersonnel',
  components: {
  },
  data () {
    return {
      list: [],
    }
  },
  methods: {
    /**
     * @description                   获取项目部数据
     * @return {undefied}             无返回值
     */
    getData () {
      this.$http.get('/rest/screen/operation/projectDeptList')
        .then(res => {
          if (res.code === 0) {
            this.list = res.data
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
  },
  created () {
    this.getData()
  },
}
</script>

<style lang="less" scoped>
  .projectPersonnel {
    width: 80%;
    height: calc(40% - 8vh);
    margin-left: 13%;
    background: url('/static/img/layout/maintenance.png');
    background-size: 100% 100%;
    margin-top: 15vh;
    padding: 4vh 0 4vh 0;
    .itemContainer {
      width: 100%;
      height: 100%;
      overflow-y: scroll;
      .item {
        width: 66%;
        margin-left: 17%;
        line-height: 2.6vh;
        margin-bottom: 3%;
        font-size: 1.5vh;
        color: #dedede;
        .personnel {
          .value {
            font-size: 1.8vh;
            color: #00fcf0;
            font-weight: bold;
          }
        }
        .protectDays {
          .value {
            font-size: 1.8vh;
            color: #00fcf0;
            font-weight: bold;
          }
        }
      }
    }
  }
</style>
